/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ID, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';

export const DRAW_RULE_LENDERS_SCHEDULE_CODE = '_LNDSCH';

export const DrawRuleBasis = createEnum('DRAW_RULE_BASIS', {
  CriticalPath: 1,
  CostCenter: 2,
});

export type DrawRuleBasis = EnumSet<typeof DrawRuleBasis>;

export type DrawRuleListItemDto = WithVersion<{
  id: ID;
  code: string;
  name: string;
  canBeDeleted: boolean;
}>;

export type DrawRuleStageDto = {
  drawRuleStageId?: ID;
  criticalPathId?: ID;
  criticalPathName?: string;
  costCenterId?: ID;
  costCenterCode?: number;
  stageNumber: number;
  name: string;
  memo: string;
  isDepositStage: boolean;
  isDeductDeposit: boolean;
  jobBudgetPct?: number;
  amountDue?: number;
  pctDue?: number;
  isCriticalPathDeleted: boolean;
  status?: number;
};

export type DrawRuleCpCcDto = {
  costCenterId: ID;
  costCenterCode: string;
  criticalPathId: ID;
  criticalPathName: string;
  name: string;
  sortOrder: number;
};

export type DrawRuleCpStageDto = {
  criticalPathId: ID;
  name: string;
};

export type DrawRuleContentDto = WithVersion<{
  drawRuleId: ID;
  code: string;
  name: string;
  basis: DrawRuleBasis;
  isNotProceeding: boolean;
  stages: DrawRuleStageDto[];
}>;

export type DrawRuleSaveDto = DrawRuleContentDto;

export type DrawRuleDetailsDto = {
  criticalPathCostCenters: DrawRuleCpCcDto[];
  criticalPathStages: DrawRuleCpStageDto[];
  drawRule: DrawRuleContentDto;
};

export const isLendersScheduleCode = (code: string) => code === DRAW_RULE_LENDERS_SCHEDULE_CODE;
